<div class="container"  [ngClass]="{ 'dark-theme': isDarkMode() }">
  <div class="top-bar">

    <div class="sync-status">
      <span class="last-updated" *ngIf="homeDashboardGeneratedAt">
        Last updated: {{ homeDashboardGeneratedAt | date:'MMM d, h:mm a' }}
      </span>
      <button type="button" class="resync-btn" (click)="onResyncClick()" [disabled]="isResyncing"
        title="Refreshing your data can take a few minutes">
        <mat-icon [class.spin]="isResyncing">refresh</mat-icon>
        {{ isResyncing ? 'Syncing…' : 'Resync' }}
      </button>
    </div>

    <div class="client-filter-box" *ngIf="username === 'Meraki - Operations'">

      <mat-icon class="search-icon">search</mat-icon>

      <input type="text" placeholder="Search Client..." [(ngModel)]="clientSearch" (input)="filterClients()"
        class="client-input" />

      <div class="dropdown" *ngIf="clientSearch">

        <div class="dropdown-item" *ngFor="let client of filteredClientList" (click)="selectClient(client)">
          {{ client }}
        </div>

      </div>

    </div>

  </div>
  <div class="statistics-container">
    <mat-card class="stat-card total-voyages">
      <div class="card-icon"><mat-icon>anchor</mat-icon></div>
      <mat-card-title>Total Voyages</mat-card-title>
      <mat-card-content>
        <h2 *ngIf="!isLoadingStats; else statsSkeleton">{{ totalVoyages }}</h2>
      </mat-card-content>
    </mat-card>
    <mat-card class="stat-card total-vessels-count">
      <div class="card-icon"><mat-icon>directions_boat</mat-icon></div>
      <mat-card-title>Total Vessels</mat-card-title>
      <mat-card-content>
        <h2 *ngIf="!isLoadingStats; else statsSkeleton">{{ totalVessels }}</h2>
      </mat-card-content>
    </mat-card>
    <mat-card class="stat-card active-vessels">
      <div class="card-icon"><mat-icon>check_circle</mat-icon></div>
      <mat-card-title>Active Vessels</mat-card-title>
      <mat-card-content>
        <h2 *ngIf="!isLoadingStats; else statsSkeleton">{{ activeVessels }}</h2>
      </mat-card-content>
    </mat-card>

    <mat-card class="stat-card inactive-vessels">
      <div class="card-icon"><mat-icon>pause_circle</mat-icon></div>
      <mat-card-title>Inactive Vessels</mat-card-title>
      <mat-card-content>
        <h2 *ngIf="!isLoadingStats; else statsSkeleton">
          {{ inactiveVessels }}
        </h2>
      </mat-card-content>
    </mat-card>

    <mat-card class="stat-card fuel-underperf" [matTooltip]="fuelTooltipContent || 'No underperforming vessels'"
      matTooltipPosition="above">
      <div class="card-icon"><mat-icon>local_gas_station</mat-icon></div>
      <mat-card-title>Voy Underperf(Fuel) </mat-card-title>
      <mat-card-content>
        <h2 *ngIf="!isLoadingStats; else statsSkeleton">
          {{ underPerformanceFuel }}
        </h2>
      </mat-card-content>
    </mat-card>
    <mat-card class="stat-card time-underperf" [matTooltip]="timeTooltipContent || 'No underperforming vessels'"
      matTooltipPosition="above">
      <div class="card-icon"><mat-icon>schedule</mat-icon></div>
      <mat-card-title>Voy Underperf(Time)</mat-card-title>
      <mat-card-content>
        <h2 *ngIf="!isLoadingStats; else statsSkeleton">
          {{ underPerformanceTime }}
        </h2>
      </mat-card-content>
    </mat-card>
  </div>

  <ng-template #statsSkeleton>
    <div class="skeleton-value skeleton"></div>
  </ng-template>

  <!-- Graphs Section (Images) -->
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-6">
        <div class="row">
          <div class="col-md-6 col-sm-12">
            <div class="graph-card" (mouseenter)="hoverLaden = true" (mouseleave)="hoverLaden = false"
              (mouseenter)="onCardMouseEnter('laden')" (mouseleave)="onCardMouseLeave('laden')">
              <div class="card-table">
                <div *ngIf="!isLoadingLadenChart; else ladenSkeleton">
                  <div #ladenChartContainer [chart]="ladenChart" class="graphId" (click)="onGraphClick()"></div>
                </div>
              </div>
              <div class="tooltip-message" [class.show]="tooltipStates.laden" *ngIf="hoverLaden">
                If you want to see the detail view click on this widget
              </div>
            </div>
          </div>
          <div class="col-md-6 col-sm-12">
            <div class="graph-card" (mouseenter)="hoverBallast = true" (mouseleave)="hoverBallast = false"
              (mouseenter)="onCardMouseEnter('ballast')" (mouseleave)="onCardMouseLeave('ballast')">
              <div class="card-table">
                <div *ngIf="!isLoadingBallastChart; else ballastSkeleton">
                  <div #ballastChartContainer [chart]="ballastChart" class="graphId" (click)="onGraphClick()"></div>
                </div>
              </div>
              <div class="tooltip-message" [class.show]="tooltipStates.ballast" *ngIf="hoverBallast">
                If you want to see the detail view click on this widget
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 col-sm-12">
            <div class="graph-card-wrapper">
              <div class="graph-card1 table" (mouseenter)="onCardMouseEnter('table')"
                (mouseleave)="onCardMouseLeave('table')">
                <div class="tableTitle" [class.hidden]="hoverTable">
                  Charter Party Performance
                </div>
                <div [class.hidden]="hoverTable" (click)="onTableClick()">
                  <div *ngIf="!isLoadingTable; else tableSkeleton">
                    <app-performance-table class="table" [data]="summaryData" [totalRecords]="fleetViewTotalRecords"></app-performance-table>
                  </div>
                  <div class="tooltip-message" [class.show]="tooltipStates.table">
                    If you want to see the detail view click on this widget
                  </div>
                </div>
                <!-- <img
                  src="../../../assets/images/table.jpg"
                  alt="Charter Party Table"
                  class="card-image"
                  [class.hidden]="hoverTable"
                  class="images"
                  *ngIf="isDataLoaded && username === 'Meraki - Operations'"
                />
                <img
                  src="../../../assets/images/charterparty_table_client.jpg"
                  alt="Charter Party Table"
                  class="card-image"
                  [class.hidden]="hoverTable"
                  class="images"
                  *ngIf="isDataLoaded && username !== 'Meraki - Operations'"
                /> -->

                <!-- <div class="card-table" [class.visible]="hoverTable">
                  <app-performance-table  [isHovered]="hoverTable"></app-performance-table>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Table & Map Section (Images) -->
      <div class="col-md-6">
        <div class="graph-card1 map" (click)="openMapFullscreen()">
          <button mat-icon-button *ngIf="isMapFullscreen" class="close-btn"
            (click)="closeMapFullscreen(); $event.stopPropagation()">
            <mat-icon>close</mat-icon>
          </button>

          <app-map [class.fullscreen]="isMapFullscreen"></app-map>
        </div>
      </div>
    </div>
  </div>
  <div class="ais-wrapper-reset" *ngIf="aisTableData && aisTableData.length > 0">
    <div class="ais-dashboard">

      <div class="dashboard-top">
        <div class="heading">
          <div class="main-icon">⚓</div>

          <div>
            <h2>AIS ETA Vessel Analytics</h2>
            <p>Real-time ETA, distance & speed intelligence</p>
          </div>
        </div>

        <div class="speed-selector" style="display: flex; align-items: center;">
          <label for="speedDropdown"
            style="color: #a4c4e6; font-size: 12px; margin-right: 8px; font-weight: 600;">Simulated Speed:</label>
          <select id="speedDropdown" [(ngModel)]="globalSpeed" (ngModelChange)="applyGlobalSpeed()"
            style="background: rgba(3,18,40,0.8); color: #fff; border: 1px solid rgba(88,190,255,0.4); border-radius: 6px; padding: 6px 10px; font-size: 13px; outline: none; cursor: pointer; box-shadow: 0 4px 10px rgba(0,0,0,0.2);">
            <option [ngValue]="10">10.0 KTS</option>
            <option [ngValue]="11">11.0 KTS</option>
            <option [ngValue]="11.5">11.5 KTS</option>
            <option [ngValue]="12">12.0 KTS</option>
            <option [ngValue]="12.5">12.5 KTS</option>
            <option [ngValue]="13">13.0 KTS</option>
            <option [ngValue]="13.5">13.5 KTS</option>
            <option [ngValue]="14">14.0 KTS</option>
            <option [ngValue]="15">15.0 KTS</option>
          </select>
        </div>

        <!-- <div class="live-feed">
      <span class="pulse"></span>
      LIVE AIS FEED
      <small>11 Jun 2025 11:36 UTC</small>
    </div> -->
      </div>

      <div class="ais-grid">
        <table>
          <thead>
            <tr>
              <th rowspan="2">#</th>
              <th rowspan="2">VESSEL</th>

              <th colspan="3" class="port blue-h">⚓ PORT SAID</th>
              <th colspan="3" class="port purple-h">🚢 NOVOROSSIYSK</th>
              <th colspan="3" class="port green-h">🗼 PRIMORSK</th>

              <th rowspan="2">LAST AIS</th>
              <th rowspan="2">LAT</th>
              <th rowspan="2">LONG</th>
            </tr>

            <tr class="sub-head">
              <th>ETA UTC</th>
              <th>NM</th>
              <th>KTS</th>

              <th>ETA UTC</th>
              <th>NM</th>
              <th>KTS</th>

              <th>ETA UTC</th>
              <th>NM</th>
              <th>KTS</th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let row of aisTableData; let i=index">

              <td class="index-cell">
                <span class="green-dot"></span>{{i+1}}
              </td>

              <td class="ship-cell group-border">
                <div class="ship-name">{{row.vessel_name}}</div>
                <div class="imo">IMO: {{row.imo}}</div>
              </td>

              <!-- PORT SAID -->
              <td class="eta-cell">
                <div class="date-part">{{ row.portSaidEta | date:'dd MMM yyyy':'UTC' }}</div>
                <div class="time-part">{{ row.portSaidEta | date:'HH:mm':'UTC' }}</div>
              </td>

              <td class="num">
                {{ row.portSaidDistance | number:'1.0-0' }}
              </td>

              <td class="speed blue group-border">
                <input type="number" step="0.1" [(ngModel)]="row.speed" (ngModelChange)="recalculateETA(row)"
                  class="speed-input blue">
              </td>

              <!-- NOVO -->
              <td class="eta-cell">
                <div class="date-part">{{ row.novoEta | date:'dd MMM yyyy':'UTC' }}</div>
                <div class="time-part">{{ row.novoEta | date:'HH:mm':'UTC' }}</div>
              </td>

              <td class="num">
                {{ row.novoDistance | number:'1.0-0' }}
              </td>

              <td class="speed purple group-border">
                <input type="number" step="0.1" [(ngModel)]="row.speed" (ngModelChange)="recalculateETA(row)"
                  class="speed-input purple">
              </td>

              <!-- PRIMORSK -->
              <td class="eta-cell">
                <div class="date-part">{{ row.primorskEta | date:'dd MMM yyyy':'UTC' }}</div>
                <div class="time-part">{{ row.primorskEta | date:'HH:mm':'UTC' }}</div>
              </td>

              <td class="num">
                {{ row.primorskDistance | number:'1.0-0' }}
              </td>

              <td class="speed green group-border">
                <input type="number" step="0.1" [(ngModel)]="row.speed" (ngModelChange)="recalculateETA(row)"
                  class="speed-input green">
              </td>

              <!-- LAST AIS -->
              <td class="eta-cell">
                <div class="date-part">{{ row.lastAis | date:'dd MMM yyyy':'UTC' }}</div>
                <div class="time-part">{{ row.lastAis | date:'HH:mm':'UTC' }}</div>
              </td>

              <td class="coord">
                {{ row.lat | number:'1.0-2' }}
              </td>

              <td class="coord">
                {{ row.lng | number:'1.0-2' }}
              </td>

            </tr>
          </tbody>
        </table>
      </div>

      <!-- <div class="stats-row">
    <div class="stat">⚙ 12.5 KTS <span>Default Speed</span></div>
    <div class="stat">📍 2,110 NM <span>Avg Distance</span></div>
    <div class="stat">🕒 7d 04h <span>Avg Time</span></div>
    <div class="stat">🚢 3 <span>Active Vessels</span></div>
  </div> -->

      <div
        style="display: flex; justify-content: flex-end; align-items: center; margin-top: 12px; font-size: 11px; color: #8eaed0;">
        <span class="ai-badge" style="margin-left: 0; margin-right: 8px;"> AIS Data Calculated</span>
        <em>Try adjusting the Simulated Speed to recalculate ETAs</em>
      </div>

    </div>
  </div>
</div>

<!-- Global Skeleton Templates -->
<ng-template #ladenSkeleton>
  <div class="skeleton-chart skeleton"></div>
</ng-template>

<ng-template #ballastSkeleton>
  <div class="skeleton-chart skeleton"></div>
</ng-template>

<ng-template #tableSkeleton>
  <div class="skeleton-table-container">
    <div class="skeleton-table-row skeleton" *ngFor="let i of [1, 2, 3, 4, 5, 6, 7, 8]"></div>
  </div>
</ng-template>